<template>
  <header>
    <div class="row border-bottom">
      <div class="col-12 my-2">
        <div class="logo" ></div>
      </div>
    </div>

    <div class="row my-2">
      <div @click="onTopPage()" class="main-title col-sm-12">
        <span class="title-lg first-child text-center">よくあるご質問</span>
      </div>
    </div>

    <nav v-if="breadcrumb" aria-label="breadcrumb" class="my-2">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a @click="onTopPage()" href="javascript:;">トップページ</a>
        </li>

        <template v-for="idx in 5" >
          <li :key="`breadcrumb_${idx}`" v-if="breadcrumb['CATE_LEVEL_NO' + idx]" class="breadcrumb-item">
            <template v-if="breadcrumb['CATE_LEVEL_NO' + (idx + 1)] || breadcrumb.FAQ_NO">
              <a @click="onCategoryClick(breadcrumb['CATE_LEVEL_NO' + idx])" href="javascript:;">{{ breadcrumb['CATE_LEVEL_NO' + idx + "_NM"] }}</a>
            </template>
            <template v-else>
              {{ breadcrumb['CATE_LEVEL_NO' + idx + "_NM"] }}
            </template>
          </li>
        </template>
      </ol>
    </nav>
  </header>
</template>

<script>
import SiteConstants from 'assets/const/SiteConstants.json';

export default {
  /*
  * Name of component
  */
  name: "FaqHeader",
  props:{
    breadcrumb: {
      type: Object,
      default: null,
    }
  },
  methods:{
    onTopPage(){
      this.$router.push({ name: SiteConstants.PG010, query: { pageNo: 50 }});
      this.$emit('onTopPage')
    },
    onCategoryClick(categoryNo){
      this.$router.push({ name: SiteConstants.PG010, query: { pageNo: 51, categoryNo : categoryNo }});
    },
  }
}
</script>